import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  ACADEMY_PROJECT_MODAL_STAGES,
  setAcademyProjectModalStage,
} from 'features/classCreation';
import AcademyProjectModal from '../AcademyProjectModal';
import ToggleChip from 'components/ToggleChip';

export default function AcademyProjectChip() {
  const dispatch = useDispatch();
  const handleModalStage = useCallback(() => {
    dispatch(setAcademyProjectModalStage(ACADEMY_PROJECT_MODAL_STAGES.create));
  }, [dispatch]);

  return (
    <>
      <AcademyProjectModal />
      <ToggleChip
        label="Add Case Study"
        onAdd={handleModalStage}
        className="m-r-xs m-b-xxs"
      />
    </>
  );
}
